import React from 'react'
import classNames from 'classnames'
import styles from './Tiles.module.scss'
import Link from 'next/link'

const Tiles = ({ id, tilesData = [], columns = 4 }) => {
  const getTileClassNames = (tile) => {
    const classNames = [styles.tileDefaultState]
    if (tile.hoverHtml) {
      classNames.push(styles.hasOverlay)
    } else if (tile.disabled) {
      classNames.push(styles.disabledTile)
    }
    return classNames
  }

  const getStatusClassNames = (status, customColour) => {
    const classNames = [styles.labelTab]
    if (status) {
      classNames.push(styles[status.toString().toLowerCase()])
    }
    if (customColour) {
      classNames.push(styles[customColour])
    }

    return classNames
  }

  const TileInner = ({ tile }) => {
    return (
      <div key={tile.tileId} className={classNames(getTileClassNames(tile))}>
        {tile.hoverHtml && <div className={styles.hoverHtml}>{tile.hoverHtml}</div>}
        <div className={classNames(styles.serviceLink)}>
          <div className={classNames(styles.iconContainer)}>
            <img src={'/images/' + tile.icon} className="icon" alt={tile.title + ' icon'} />
          </div>
          <p className={classNames(styles.title)}>{tile.title}</p>
          <div className={classNames(styles.desc)}>{tile.desc}</div>
          {tile.children && <div className="custom mt-2">{tile.children}</div>}
          {tile.tabText && (
            <div className={classNames(styles.status)}>
              <div
                className={classNames(getStatusClassNames(tile.tabText, tile.tabColour || null))}
              >
                <span>{tile.tabText}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  const onTileClick = async (event, tile) => {
    // if (data.url) {
    //   router.push(data.url)
    // } else if (data.onClick) {
    //   data.onClick(data)
    // }
    event.preventDefault()
    if (tile.joinAction) {
      await tile.joinAction(tile)
    }
  }

  return (
    <div id={id} className={classNames(styles.tilesWrapper)}>
      {tilesData.map((tile, index) =>
        tile.joinAction && !tile.hoverHtml ? (
          <Link key={index} href={'#'}>
            <a
              className={classNames(styles.tile, styles['tileCol' + columns], tile.className)}
              onClick={async (event) => {
                await onTileClick(event, tile)
              }}
              role="button"
              tabIndex={0}
            >
              <TileInner key={tile.tileId} tile={tile} />
            </a>
          </Link>
        ) : tile.url && !tile.hoverHtml ? (
          <Link key={index} href={tile.url}>
            <a
              className={classNames(styles.tile, styles['tileCol' + columns], tile.className)}
              role="button"
              tabIndex={0}
              target={tile.target ? tile.target : '_self'}
            >
              <TileInner key={tile.tileId} tile={tile} />
            </a>
          </Link>
        ) : (
          <div
            key={index}
            className={classNames(styles.tile, styles['tileCol' + columns], tile.className)}
          >
            <TileInner key={tile.tileId} tile={tile} />
          </div>
        )
      )}
    </div>
  )
}

export default Tiles
